import { AnalyticsBrowser } from '@segment/analytics-next'

declare global {
  interface Window {
    analytics: AnalyticsBrowser
  }
}

export const analytics = window.analytics

export const SegmentAnalyticsProvider = (props: React.PropsWithChildren) => props.children

export const segmentClient = window.analytics as AnalyticsBrowser
